import { useState, useEffect } from 'react'
import styles from './InstallBanner.module.css'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

export function InstallBanner() {
  const [promptEvent, setPromptEvent] = useState<BeforeInstallPromptEvent | null>(null)
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('fasico:pwa_installed') === 'true' ||
          sessionStorage.getItem('fasico:pwa_dismissed') === 'true'
  )

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault()
      setPromptEvent(e as BeforeInstallPromptEvent)
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  if (!promptEvent || dismissed) return null

  const handleInstall = async () => {
    await promptEvent.prompt()
    const { outcome } = await promptEvent.userChoice
    if (outcome === 'accepted') {
      localStorage.setItem('fasico:pwa_installed', 'true')
    }
    setDismissed(true)
  }

  const handleDismiss = () => {
    sessionStorage.setItem('fasico:pwa_dismissed', 'true')
    setDismissed(true)
  }

  return (
    <div className={styles.banner} role="complementary" aria-label="Instalar aplicación">
      <span className={styles.text}>📱 Instala Fásico en tu celular para acceso rápido</span>
      <div className={styles.actions}>
        <button className={styles.install} onClick={handleInstall}>Instalar</button>
        <button className={styles.close} onClick={handleDismiss} aria-label="Cerrar">×</button>
      </div>
    </div>
  )
}
